import { render } from "./CircleProgress.vue?vue&type=template&id=49af6a0a&scoped=true"
import script from "./CircleProgress.vue?vue&type=script&lang=js"
export * from "./CircleProgress.vue?vue&type=script&lang=js"

import "./CircleProgress.vue?vue&type=style&index=0&id=49af6a0a&scoped=true&lang=css"

import exportComponent from "/Users/delowar/Projects/npm/vue3-circle-progress/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49af6a0a"]])

export default __exports__